import { Grid, Skeleton, Stack } from "@/components/ui"

export const FeedSectionSkeleton = () => (
  <Stack gap="300" className="px-gut @container w-full" aria-hidden>
    <Skeleton className="h-6 w-1/2 max-w-60" />
    <Grid cols={2} colsDesktop={4} gap="300">
      <Skeleton shape="card" className="aspect-tile" />
      <Skeleton shape="card" className="aspect-tile" />
      <Skeleton shape="card" className="aspect-tile hidden @3xl:block" />
      <Skeleton shape="card" className="aspect-tile hidden @3xl:block" />
    </Grid>
  </Stack>
)
